import api from '@/axios/api';
import axios from '@/axios/fetch';
import useUserHooks from '@/hooks/user.hooks';
import { PageRequest } from '@/interface/index.interface';
import { definitions } from '@/types/api';
/** analysis.services  */
const analysisService = () => {
  const userHooks = useUserHooks();

  /**
   * 学生端-根据userId查询作业列表页
   */
  const listAssignHomeworksByUserId = async (param: PageRequest<{
    assignStatus?: number;
  }>): Promise<Required<definitions['Page«AssignHomework»']>> => {
    const { data } = await axios.post('./api/AssignHomework/queryAssignHomeWorksByUserId', {
      ...param, userId: userHooks.getUserInfo().code,
    });
    return data.data;
  };

  /** 根据jobId查询job模块列表 */
  const listQuestionModuleByJobId = async (jobId: string): Promise<definitions['CustomQuestionModule'][]> => {
    const { data } = await api.listCustomQuestionModuleByCaId(jobId);
    return data.data;
  };

  /** 根据moduleId查询问题列表 */
  const listQuestionByModuleId = async (moduleId: string): Promise<definitions['CustomQuestion'][]> => {
    const { data } = await api.listCustomQuestionByMId(moduleId);
    return data.data;
  };

  /**
   * 根据分配ID ：根据作业id查询学生做题的记录
   * 如果没传userId，表示学生端-直接取当前账户
   * 传了userId，表示教师端-教师查询，根据点击的学生查
   */
  const listStuQuestionAnswer = async (assignmentId: string, userId?: string): Promise<definitions['StuQuestionAnswer'][]> => {
    const code = userId || userHooks.getUserInfo().code;
    const { data } = await axios.post(`./api/stuQuestionAnswer/queryByAssignId/${assignmentId}/${code}`);
    return data.data;
  };

  /**
   * 学生端-做题
   * @param assignmentId 分配表的id
   * @param questionCount 答题批次
   * @param questionId 问题id
   * @param stuAnswer 学生答案
   */
  const saveStuAnswerApi = async (param: {assignmentId: string; questionCount: number; questionId: string; stuAnswer: string}) => {
    await axios.post('./api/stuQuestionAnswer/studentsProblem', {
      assignId: param.assignmentId,
      questionCount: param.questionCount,
      questionId: param.questionId,
      stuAnswer: param.stuAnswer,
      userId: userHooks.getUserInfo().code,
    });
  };

  /**
   * 学生端-提交自己作业
   * @param assignmentId 分配表的ID
   */
  const saveAssignmentStatusApi = async (assignmentId: string) => {
    await axios.post('./api/StuQuestionsSubmitBatchRecords/submitBatch', {
      assignId: assignmentId,
      userId: userHooks.getUserInfo().code,
    });
  };

  /**
   * 教师端提前结束
   * @param id 分配表的id
   */
  const saveTeacherAdvanceEnd = async (id: string) => {
    const data = await axios.post(`./api/AssignHomework/jobEndedPrematurely/${id}`);
    return data;
  };

  /**
   * 教师批改填空题分数
   * @param assignmentId 被分配的id
   * @param questionId 问题id
   * @param score 教师批改分数
   * @param stuCode 被批改的学生账号
   */
  const saveTeacherCorrectQuestion = async (assignmentId: string, questionId: string, score: number, stuCode: string) => {
    const data = await axios.post('./api/stuQuestionAnswer/teacherSubjectScore', {
      assignId: assignmentId,
      questionId,
      score,
      userId: stuCode,
      gradingState: true,
    });
    return data;
  };

  /**
   * 根据 分配id和学生code 查询得分
   */
  const queryScoreDataByAssignIdStuCode = async (assignmentId: string, stuCode?: string) => {
    const userId = stuCode || userHooks.getUserInfo().code;
    const { data } = await axios.post(`./api/stuQuestionAnswer/getSumScoreByAssignId/${assignmentId}/${userId}`);
    return data.data;
  };

  return {
    listAssignHomeworksByUserId,
    listQuestionModuleByJobId,
    listQuestionByModuleId,
    listStuQuestionAnswer,
    saveStuAnswerApi,
    saveAssignmentStatusApi,
    saveTeacherAdvanceEnd,
    saveTeacherCorrectQuestion,
    queryScoreDataByAssignIdStuCode,
  };
};

export default analysisService;
